export default __webpack_public_path__ + "static/media/green-tick.30a58d02.svg";